import {createFeatureSelector, createSelector} from '@ngrx/store';
import { IIndustryState } from '@app/stores';

const selectIndustry = createFeatureSelector<IIndustryState>('industries');

export const getIndustry = createSelector(selectIndustry, (state: IIndustryState) => state.industry);

export const getIndustries = createSelector(selectIndustry, (state: IIndustryState) => state.industries);

export const getIndustriesError = createSelector(selectIndustry, (state: IIndustryState) => state.error);

export const getIndustriesSuccess = createSelector(selectIndustry, (state: IIndustryState) => state.success);

export const getPaginatedIndustries = createSelector(selectIndustry, (state: IIndustryState) => state.paginatedIndustries);
